/**
 * Copyright © 2025 Farmlands Co-operative Society Limited. All rights reserved.
 *
 * This document contains confidential information and is the property of Farmlands.
 * Unauthorised reproduction or distribution of any part of this publication is prohibited without written consent.
 */

import React from 'react';
import { Box, styled } from '@mui/material';

import { TestIds } from '../../../../testIds';
import { Label, ProductPriceDetails } from './ProductPriceDetails';
import { ItemLabel } from '../../../../components/styled';
import { StockAvailability } from '../StockAvailability/StockAvailability';

const Container = styled('div')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: '8px',
  minWidth: '200px',
  [theme.breakpoints.down('sm')]: {
    marginBottom: '4px',
  },
}));

interface Props {
  items: Label[];
  itemNumber: string;
  productId?: string;
  noPriceAvailable: boolean;
  orderStatusBadge?: React.ReactNode;
  condensed?: boolean;
}

export const ProductHeaderDetails: React.FC<Props> = ({
  items,
  itemNumber,
  noPriceAvailable,
  orderStatusBadge,
  condensed,
  productId,
}) => {
  return (
    <Container>
      {orderStatusBadge}
      {!condensed && itemNumber && (
        <Box display='flex' flexDirection={'row'} gap='4px'>
          <ItemLabel variant='caption'>SKU:</ItemLabel>
          <ItemLabel variant='caption' data-testid={TestIds.feat.product.card.SKU}>
            {itemNumber}
          </ItemLabel>
        </Box>
      )}
      <StockAvailability productId={Number(productId)} />

      {!noPriceAvailable && <ProductPriceDetails items={items} />}
      {noPriceAvailable && (
        <ItemLabel variant='body2' data-testid={TestIds.feat.product.card.priceNotAvailable}>
          Price unavailable
        </ItemLabel>
      )}
    </Container>
  );
};
